import React from "react";
import { API_URL as SERVER } from "../config";

interface PhotoHeroProps {
  images: { id: number; url: string }[];
  onOpen: (i: number) => void;
}

export default function PhotoHero({ images, onOpen }: PhotoHeroProps) {
  if (images.length === 0) return null;

  const count = images.length;

  if (count === 1) {
    return (
      <div style={{ borderRadius: 12, overflow: "hidden", display: "flex", justifyContent: "center" }}>
        <button onClick={() => onOpen(0)} style={{ ...tileBtn, width: "auto", height: "auto" }}>
          <img src={`${SERVER}${images[0].url}`} alt="" style={{ width: "auto", height: "auto", maxWidth: "100%", maxHeight: 560, display: "block" }} />
        </button>
      </div>
    );
  }

  if (count === 2) {
    return (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4, height: 340, borderRadius: 12, overflow: "hidden" }}>
        {images.map((img, i) => (
          <button key={img.id} onClick={() => onOpen(i)} style={tileBtn}>
            <img src={`${SERVER}${img.url}`} alt="" style={fillImg} />
          </button>
        ))}
      </div>
    );
  }

  if (count === 3) {
    return (
      <div style={{
        display: "grid",
        gridTemplateAreas: '"hero small1" "hero small2"',
        gridTemplateColumns: "2fr 1fr",
        gridTemplateRows: "1fr 1fr",
        gap: 4,
        height: 400,
        borderRadius: 12,
        overflow: "hidden",
      }}>
        <button onClick={() => onOpen(0)} style={{ ...tileBtn, gridArea: "hero" }}>
          <img src={`${SERVER}${images[0].url}`} alt="" style={fillImg} />
        </button>
        <button onClick={() => onOpen(1)} style={{ ...tileBtn, gridArea: "small1" }}>
          <img src={`${SERVER}${images[1].url}`} alt="" style={fillImg} />
        </button>
        <button onClick={() => onOpen(2)} style={{ ...tileBtn, gridArea: "small2" }}>
          <img src={`${SERVER}${images[2].url}`} alt="" style={fillImg} />
        </button>
      </div>
    );
  }

  if (count === 4) {
    return (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridTemplateRows: "1fr 1fr", gap: 4, height: 380, borderRadius: 12, overflow: "hidden" }}>
        {images.map((img, i) => (
          <button key={img.id} onClick={() => onOpen(i)} style={tileBtn}>
            <img src={`${SERVER}${img.url}`} alt="" style={fillImg} />
          </button>
        ))}
      </div>
    );
  }

  // 5+ images: Airbnb-style hero grid
  const visible = images.slice(0, 5);

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "2fr 1fr 1fr",
      gridTemplateRows: "1fr 1fr",
      gap: 4,
      height: 480,
      borderRadius: 12,
      overflow: "hidden",
    }}>
      {/* Hero — spans both rows */}
      <button onClick={() => onOpen(0)} style={{ ...tileBtn, gridRow: "1 / 3" }}>
        <img src={`${SERVER}${visible[0].url}`} alt="" style={fillImg} />
      </button>
      {/* Small tiles 1–3 */}
      {visible.slice(1, 4).map((img, i) => (
        <button key={img.id} onClick={() => onOpen(i + 1)} style={tileBtn}>
          <img src={`${SERVER}${img.url}`} alt="" style={fillImg} />
        </button>
      ))}
      {/* Last tile — with "Show all" overlay */}
      <div style={{ position: "relative" }}>
        <button onClick={() => onOpen(4)} style={{ ...tileBtn, position: "absolute", inset: 0 }}>
          <img src={`${SERVER}${visible[4].url}`} alt="" style={fillImg} />
        </button>
        <button onClick={() => onOpen(0)} style={showAllOverlay}>
          Show all {images.length} photos
        </button>
      </div>
    </div>
  );
}

const tileBtn: React.CSSProperties = {
  padding: 0, border: "none", background: "transparent",
  cursor: "pointer", display: "block", width: "100%", height: "100%",
};

const fillImg: React.CSSProperties = {
  width: "100%", height: "100%", objectFit: "cover", display: "block",
};

const showAllOverlay: React.CSSProperties = {
  position: "absolute", bottom: 12, right: 12,
  background: "rgba(255,255,255,0.95)", border: "1px solid #374151",
  borderRadius: 8, padding: "8px 16px",
  fontSize: 13, fontWeight: 600, cursor: "pointer",
  whiteSpace: "nowrap", zIndex: 1,
};
